/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./project-get-list-action-body').ProjectGetListActionBody} ProjectGetListActionBody
 */

/**
 * @typedef {import('./project-get-list-action-response').ProjectGetListActionResponse} ProjectGetListActionResponse
 */

/**
 * The path of the ProjectGetListAction action.
 */
export const projectGetListActionPath = new SweetPath('/api/project/project', { path: '{param}' });

/**
 * Creates a contextualized ProjectGetListAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createProjectGetListAction(axios) {
  /**
   * The projectGetListAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<ProjectGetListActionResponse>}
   */
  function projectGetListAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = projectGetListActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return projectGetListAction;
}
